<template>
  <div class="documenti-fiscali">
    <div class="glass-header">
      <button @click="$router.push({ name: 'Gestionale' })" class="back-btn">
        <i class="fas fa-arrow-left"></i> Torna al Gestionale
      </button>
      <h1>Documenti Fiscali</h1>
    </div>

    <div class="glass-card">
      <div class="filters">
        <div class="filter-group">
          <label>Da:</label>
          <input type="date" v-model="filters.dataDal" @change="fetchDocumenti" class="glass-input">
        </div>
        <div class="filter-group">
          <label>A:</label>
          <input type="date" v-model="filters.dataAl" @change="fetchDocumenti" class="glass-input">
        </div>
      </div>

      <div class="table-container">
        <table class="glass-table" v-if="documenti.length">
          <thead>
            <tr>
              <th>Data</th>
              <th>Progressivo</th>
              <th class="hide-mobile">Etichetta</th>
              <th>Totale</th>
              <th>Stato</th>
              <th>Azioni</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="doc in documenti" :key="doc.progressivo">
              <td>{{ formatDate(doc.dataCreazione) }}</td>
              <td>{{ doc.progressivo }}</td>
              <td class="hide-mobile">{{ doc.etichetta }}</td>
              <td class="price">€ {{ doc.totale.toFixed(2) }}</td>
              <td>
                <span :class="'status-' + doc.stato">
                  {{ doc.stato === 1 ? 'Attivo' : 'Annullato' }}
                </span>
              </td>
              <td>
                <button v-if="doc.stato === 1" @click="confirmCancel(doc)" class="cancel-btn">
                  Annulla
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <div v-else-if="loading" class="loading">Caricamento in corso...</div>
        <div v-else class="no-data">Nessun documento trovato per il periodo selezionato.</div>
      </div>
    </div>
  </div>
</template>

<script>
import { store } from '../store/store.js'

export default {
    name: 'DocumentiFiscali',
    data() {
        return {
            store,
            documenti: [],
            loading: false,
            filters: {
                dataDal: new Date().toISOString().split('T')[0],
                dataAl: new Date().toISOString().split('T')[0],
            }
        }
    },
    methods: {
        async fetchDocumenti() {
            this.loading = true;
            try {
                const response = await this.axios.post(this.store.path + 'scontrino/list', {
                    filters: {
                        dataDal: this.filters.dataDal + 'T00:00:00',
                        dataAl: this.filters.dataAl + 'T23:59:59'
                    }
                }, {
                    headers: { authorization: `Bearer ${JSON.parse(localStorage.token)}` }
                });
                
                this.documenti = response.data.vendita || [];
            } catch (error) {
                console.error("Errore fetch documenti:", error);
                alert("Errore nel caricamento dei documenti.");
            } finally {
                this.loading = false;
            }
        },
        async confirmCancel(doc) {
            if (confirm(`Sei sicuro di voler annullare il documento ${doc.progressivo}?`)) {
                try {
                    await this.axios.post(this.store.path + 'scontrino/cancel', {
                        progressivo: doc.progressivo,
                        data: doc.dataCreazione.split('T')[0],
                        totale: doc.totaleVendite
                    }, {
                        headers: { authorization: `Bearer ${JSON.parse(localStorage.token)}` }
                    });
                    
                    alert("Documento annullato con successo!");
                    this.fetchDocumenti();
                } catch (error) {
                    console.error("Errore annullamento:", error);
                    alert("Errore nell'annullamento del documento: " + (error.response?.data?.message || error.message));
                }
            }
        },
        formatDate(dateStr) {
            if (!dateStr) return "-";
            const date = new Date(dateStr);
            return date.toLocaleDateString('it-IT') + ' ' + date.toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' });
        }
    },
    mounted() {
        this.fetchDocumenti();
    }
}
</script>

<style scoped>
.documenti-fiscali {
  padding: 20px;
  background-color: #f5f5f7;
  min-height: 100vh;
}

.glass-header {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 30px;
}

.back-btn {
  background: white;
  border: 1px solid #ddd;
  padding: 8px 16px;
  border-radius: 8px;
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
}

.glass-card {
  background: white;
  border: 1px solid #eee;
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.08);
}

.filters {
  display: flex;
  gap: 15px;
  margin-bottom: 25px;
  flex-wrap: wrap;
  justify-content: center;
}

.filter-group {
  display: flex;
  align-items: center;
  gap: 8px;
}

.glass-input {
  border: 1px solid #ddd;
  padding: 8px 12px;
  border-radius: 8px;
  font-family: inherit;
}

.table-container {
  overflow-x: auto;
}

.glass-table {
  width: 100%;
  border-collapse: collapse;
  text-align: left;
  min-width: 600px;
}

.glass-table th, .glass-table td {
  padding: 12px;
  border-bottom: 1px solid #f0f0f0;
}

.glass-table th {
  color: #3b82f6;
  font-weight: bold;
}

.price {
  font-weight: bold;
  color: #10b981;
}

.status-1 {
  color: #10b981;
  background: rgba(16, 185, 129, 0.1);
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 0.85rem;
}

.status-0 {
  color: #ef4444;
  background: rgba(239, 68, 68, 0.1);
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 0.85rem;
}

.cancel-btn {
  background: #ef4444;
  color: white;
  border: none;
  padding: 6px 12px;
  border-radius: 6px;
  cursor: pointer;
}

@media (max-width: 600px) {
  .hide-mobile {
    display: none;
  }
  .documenti-fiscali {
    padding: 10px;
  }
  .glass-table {
    min-width: auto;
    font-size: 0.9rem;
  }
}

.loading, .no-data {
  text-align: center;
  padding: 30px;
  color: #64748b;
}
</style>
